import React from "react";
import CounterPart from "../common/CounterPart";
import NandithImg from "../images/nandith.webp";
import JitenImg from "../images/jiten.webp";
import HardikImg from "../images/hardik.webp";
import NishantImg from "../images/nishant.webp";
import { useTranslation } from "react-i18next";

const AdvisoryBoard = () => {
    const { t } = useTranslation();
    const data = [
        { image: NandithImg, num: "Nandith Nandakumar", name: t("strategy"), profileUrl: "", },
        { image: NishantImg, num: "Nishant Kulkarni", name: t("product"), profileUrl: "", },
        { image: "", num: "Anil Kumar", name: t("engineering"), profileUrl: "", },
        // { image: JitenImg, num: "Jiten Siddhpura", name: "Technology Platform", profileUrl: "https://www.linkedin.com/in/jiten-siddhpura-b3205036/" },
        // { image: HardikImg, num: "Hardik Nimbark", name: "Founder & CEO",  profileUrl: "https://www.linkedin.com/in/hardiknimbark" },
    ];

    return (
        <div className="">
            <CounterPart data={data} title={t("advisory_board")} />
        </div>
    );
};

export default AdvisoryBoard;
